import { Component } from '@angular/core';

@Component({
	selector: 'ft-reporting',
	templateUrl: './reporting.component.html',
	styleUrls: ['./reporting.component.scss'],
})
export class ReportingComponent {}
